import React from "react";
import PDFFile from "../PDFFile";
import PDFFileApe from "../PDFFileApe";
import PDFFileApeXMl from "../PDFFileApeXMl";
import PDFFileGdXApe from "../PDFFileGdXApe";
import PDFSimulator from "../PDFSimulator";
import { CompanyLogo } from "./hooks/useSimulatorUser";
import { PdfDownloadActionKey } from "./pdfDownloadActions";
import { EconomyCompareResult, SimulationType } from "./types";

export interface PdfDocumentParams {
  simulationResult: EconomyCompareResult | null;
  simulacaoSelected: string;
  simulatorData: any;
  infoUsina: any;
  screenShotChart: string;
  desconto: number;
  tipoContratacao: string;
  companyLogo: CompanyLogo;
}

export const buildSimulationPdfDocument = ({
  simulationResult,
  simulacaoSelected,
  simulatorData,
  infoUsina,
  screenShotChart,
  desconto,
  companyLogo,
}: PdfDocumentParams) => {
  if (!simulationResult) return null;

  // As comparações espelhadas de bateria (MLBESS/APEBESS) não geram PDF.
  const documents: Record<
    Exclude<SimulationType, "MLBESS" | "APEBESS">,
    React.ReactElement
  > = {
    ML: (
      <PDFFile
        economyData={simulationResult}
        simulatorData={simulatorData}
        livreData={simulationResult.secondSimulation}
        apeData={null as any}
        screenShotChart={screenShotChart}
        cativoData={simulationResult.firstSimulation}
        desconto={desconto}
        hasCompanyLogo={companyLogo}
      />
    ),
    MLXAPE: (
      <PDFFileApeXMl
        economyData={simulationResult}
        simulatorData={simulatorData}
        livreData={simulationResult.firstSimulation}
        apeData={simulationResult.secondSimulation}
        screenShotChart={screenShotChart}
        cativoData={null as any}
        desconto={desconto}
        infoUsina={infoUsina}
        hasCompanyLogo={companyLogo}
      />
    ),
    GDXAPE: (
      <PDFFileGdXApe
        economyData={simulationResult}
        simulatorData={simulatorData}
        gdData={simulationResult.firstSimulation}
        apeData={simulationResult.secondSimulation}
        screenShotChart={screenShotChart}
        desconto={desconto}
        hasCompanyLogo={companyLogo}
      />
    ),
    APE: (
      <PDFFileApe
        economyData={simulationResult}
        simulatorData={simulatorData}
        livreData={null as any}
        apeData={simulationResult.secondSimulation}
        screenShotChart={screenShotChart}
        cativoData={simulationResult.firstSimulation}
        desconto={desconto}
        infoUsina={infoUsina}
        hasCompanyLogo={companyLogo}
      />
    ),
  };

  return (
    documents[
      simulacaoSelected as Exclude<SimulationType, "MLBESS" | "APEBESS">
    ] ?? null
  );
};

export const buildPdfDocument = (
  actionKey: PdfDownloadActionKey,
  params: PdfDocumentParams
) => {
  const { simulationResult, simulatorData, desconto, tipoContratacao } = params;

  if (!simulationResult) return null;

  if (actionKey === "presentation") {
    return (
      <PDFSimulator
        simulatorData={simulatorData}
        desconto={desconto}
        economyData={simulationResult}
        apeData={null as any}
        cativoData={simulationResult.firstSimulation as any}
        livreData={simulationResult.secondSimulation as any}
        simulationType={
          tipoContratacao === "atacado" ? "atacadista" : "varejista"
        }
      />
    );
  }

  return buildSimulationPdfDocument(params);
};
